function calculateBookingPrice ({ categoryId, positionId }) {
  let price = this.default_season_price
  if (this.custom_season_prices) {
    // Category-specific price overrides season's default price
    for (const customSeasonPrice of this.custom_season_prices) {
      if (customSeasonPrice.category_ids.includes(categoryId)) {
        price = customSeasonPrice.price
      }
    }

    // Position-specific price overrides both default and category-specific price
    for (const customSeasonPrice of this.custom_season_prices) {
      if (customSeasonPrice.position_ids.includes(positionId)) {
        price = customSeasonPrice.price
      }
    }
  }
  return price
}

export default {
  calculateBookingPrice
}
